// extracted by mini-css-extract-plugin
export default {"uiNoteIcon":"styles_uiNoteIcon__RQ8Cf","inline":"styles_inline__+JQCd"};